import { Hero } from "../components/home/Hero";
import { Categories } from "../components/home/Categories";
import { Featured } from "../components/home/Featured";
import { Contact, Faq, HowItWorks, Trade } from "../components/home/Sections";
import { Fitting } from "../components/home/Fitting";
import { Marquee } from "../components/site/Marquee";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Categories />
      <Featured />
      <HowItWorks />
      <Fitting />
      <Trade />
      <Faq />
      <Contact />
    </main>
  );
}
